import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Tracker }        from '../../shared/entities/tracker';
import { TrackerLockEvent }        from '../../shared/entities/tracker-lock-event';
import { Position }        from '../../shared/entities/position';
import { Customer }        from '../../shared/entities/customer';
import { Observable }     from '../../../node_modules/rxjs/Observable';

import { SERVER_URL } from './server-url';
import { User } from '../entities/user';

@Injectable()
export class TrackerService {
    private trackerUrl = SERVER_URL + '/api/trackers';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/trackers';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/trackers';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/trackers';  // URL to web API
    
    private lastPositionsUrl = this.trackerUrl + '/last-positions';  // URL to web API
    
    public positions:Array<Position>;
    public trackers:Array<Tracker>;
    public customers:Array<Customer>;

    constructor (private http: Http) {}

    getTrackers(tokenLogged:string): Observable<Tracker[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.trackerUrl, {headers: headers})
                    .map(this.extractTrackersFromJSON)
                    .catch(this.handleError);
    }

    getTrackersWithCustomers(tokenLogged:string): Observable<Customer[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.trackerUrl + '/customers', {headers: headers})
                    .map(this.extractTrackersWithCustomerFromJSON)
                    .catch(this.handleError);
    }

    getTrackerById(id:number, tokenLogged:string): Observable<Tracker> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.trackerUrl + '/' + id, {headers: headers})
                    .map(this.extractTrackerFromJSON)
                    .catch(this.handleError);
    }

    getTrackerLockEvents(tokenLogged:string, idTracker:number, limitResults:number): Observable<TrackerLockEvent[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.trackerUrl + '/' + idTracker + '/lock', {headers: headers})
                    .map(this.extractTrackerLockHistoric)
                    .catch(this.handleError);
    }

    private extractTrackerLockHistoric(res: Response | any) {
        let body = res.json();
        var trackerLockEventList:TrackerLockEvent[] = [];
        
        for (let entry of body) {
            var tracker:Tracker = new Tracker(entry.tracker_id, 
                                                entry.tracker_name,
                                                null, 
                                                entry.tracker_detail,
                                                null, 
                                                null, 
                                                entry.tracker_customer_id);
            tracker.imei = entry.tracker_imei;
            
            var user:User = new User(entry.user_id, entry.user_username, null, null);

            var trackerLockEvent:TrackerLockEvent = new TrackerLockEvent(entry.id,
                                                    null, //pra não ficar estrutura circular
                                                    user,
                                                    entry.dt_log,
                                                    entry.message,
                                                    entry.is_lock_event,
                                                    entry.is_event_complete,
                                                    entry.dt_event_complete);
            
            trackerLockEventList.push(trackerLockEvent);
        }
        return trackerLockEventList;
    }

    getLastPositions(tokenLogged:string): Observable<Position[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);

        return this.http.get(this.lastPositionsUrl, {headers : headers})
                    .map(this.extractLastPositionsFromJSON)
                    .catch(this.handleError);
    }

    getPositionsByTracker(tracker:number, datetimeInit:Date, datetimeEnd:Date): Observable<Array<Position>> {
        
        var positionsUrl = this.trackerUrl + '/' + tracker + '/positions';  
        
        if (datetimeInit) {
            
            var month:number = datetimeInit.getUTCMonth() + 1;
            var day:number = datetimeInit.getDate();
            var minutes:number = datetimeInit.getUTCMinutes();
            var hours:number = datetimeInit.getHours();
            positionsUrl = positionsUrl + '?datetimeInit=' 
                    + datetimeInit.getFullYear() 
                    + '-' + month
                    + '-' + day
                    + ' ' + hours
                    + ':' + minutes;

            if (datetimeEnd) {
                var monthEnd:number = datetimeEnd.getMonth() + 1;
                var dayEnd:number = datetimeEnd.getDate();
                var minutesEnd:number = datetimeEnd.getUTCMinutes();
                var hoursEnd:number = datetimeEnd.getHours();
               
                positionsUrl = positionsUrl + '&datetimeEnd=' 
                    + datetimeEnd.getFullYear() 
                    + '-' + monthEnd
                    + '-' + dayEnd
                    + ' ' + hoursEnd
                    + ':' + minutesEnd;
            }
        }
        
        return this.http.get(positionsUrl)
                    .map(this.extractPositionsFromJSON)
                    .catch(this.handleError);
    }

    getExportLastPositions() : any {
         var exportLastPositionsUrl = this.lastPositionsUrl + '/reportPDF';  
         
         return this.http.get(exportLastPositionsUrl)
                    .map(this.exportReportPDFLastPositions)
                    .catch(this.handleError);
    }


    //Calculate route based on positions of trackers
    generateTrackerRequests(positions:Array<Position>):Array<any> {
        if (!positions) { return; }
        
        var startPoint = positions[0];
        var endPoint = positions[positions.length-1];
        var waypointsPositions = positions.slice(1, positions.length-1);

        var requests = [];
        var origin : any = startPoint.lat + ',' + startPoint.lng;
        
        var destination : any = null;
        var waypoints : Array<any> = [];
        
        var numberOfWaypoints = 0;  
        var numberOfRequest = 1;
        const limitOfWaypoints = 23;
        
        var i=0;
  
        while (i < waypointsPositions.length) {
            if (origin && numberOfWaypoints < (limitOfWaypoints * numberOfRequest)) {
                if( !waypointsPositions[i + 1] ) {
                    destination = endPoint.lat + ',' + endPoint.lng;
                    waypoints.push({location: waypointsPositions[i].lat + ',' + waypointsPositions[i].lng});
                    requests.push({origin: origin, destination: destination, waypoints: waypoints});                    
                    break;
                } else {
                    waypoints.push({location: waypointsPositions[i].lat + ',' + waypointsPositions[i].lng})//{lat: orders[i].deliveryLat, lng: orders[i].deliveryLng}, stopover: true});
                }
                numberOfWaypoints++;

            } else if (!destination && numberOfWaypoints == (limitOfWaypoints * numberOfRequest)) {
                if( !waypointsPositions[i + 1] ) {
                    destination = waypointsPositions[i].lat +','+ waypointsPositions[i].lng;
                    //destination = endPoint.lat + ',' + endPoint.lng;
                    requests.push({origin: origin, destination: destination, waypoints: waypoints});
                    //me.makeRequest(origin, destination, waypoints, map, directions);
                }
                else {
                    destination = waypointsPositions[i].lat +','+ waypointsPositions[i].lng;
                    requests.push({origin: origin, destination: destination, waypoints: waypoints});
                    //me.makeRequest(origin, destination, waypoints, map, directions);
                }
                
                numberOfRequest++;
                origin = null;
                destination = null;
                waypoints = [];
            }
            if (origin) {
              i++;
            } else {
                origin = waypointsPositions[i].lat +','+ waypointsPositions[i].lng;
            } 
        }

        return requests;
    }

    lockTracker(tokenLogged:string, tracker:Tracker, message:string, isLockEvent:boolean):Observable<number> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.trackerUrl + '/' + tracker.id + '/lock', 
                { isLockEvent: isLockEvent, message: message }, 
                { headers: headers })
                    .map(this.extractTrackerLockResponse)
                    .catch(this.handleError);
    }
    
    private extractTrackersFromJSON(res: Response | any) {
        let body = res.json();
        var trackersList:Tracker[] = [];
        
        for (let entry of body) {
            
            var tracker:Tracker = new Tracker(entry.id, entry.name, null, entry.detail, entry.color, entry.type, entry.customer_id);
            trackersList.push(tracker);
        }
        return trackersList;
    }

    private extractTrackerFromJSON(res: Response | any) {
        let tracker = res.json()[0];
        
        var trackerAux:Tracker = new Tracker(tracker.id, tracker.name, null, tracker.detail, tracker.color, tracker.type, tracker.customer_id);
        trackerAux.hasLock = tracker.has_lock;
        trackerAux.isLocked = tracker.is_locked;
        trackerAux.idLockEventPending = tracker.lock_event_pending_id;

        return trackerAux;
    }

    private extractTrackersWithCustomerFromJSON(res: Response | any) {
        let body = res.json();
        var customerList:Customer[] = [];
       // console.log('CUSTOMER LIST from tracker service11 ' + JSON.stringify(body));

        for (let entry of body) {
            var customer:Customer = new Customer(entry.customer_id, entry.customer_name, [], entry.lat, entry.lng);
            //console.log('Customer lat;lng ' + customer.lat)
            for (let tracker of entry.trackers) {
                var trackerAux:Tracker = new Tracker(tracker.id, tracker.name, null, tracker.detail, tracker.color, tracker.type, entry.customer_id);
                trackerAux.hasLock = tracker.has_lock;
                trackerAux.isLocked = tracker.is_locked;
                trackerAux.idLockEventPending = tracker.lock_event_pending_id;
                trackerAux.isUserCanLock = tracker.can_lock ? tracker.can_lock : false;
                customer.lat = tracker.lat;
                customer.lng = tracker.lng;

                customer.trackers.push(trackerAux);    
            }
            
            customerList.push(customer);
        }
        //console.log('CUSTOMER LIST from tracker service ' + JSON.stringify(customerList));
        return customerList;
    }

    private exportReportPDFLastPositions(res: any) {
        return res;
    }

    private extractTrackerLockResponse(res: Response | any) {
        let body = res.json();
        return body.idLockEventPending;
    }

    private extractLastPositionsFromJSON(res: Response | any) {
        let body = res.json();
        var positionsList:Position[] = [];

       for (let entry of body) {
            var position:Position = new Position(entry.id, entry.tracker_id, +entry.lat, +entry.lng, entry.datetime, entry.velocity, entry.start, entry.address, entry.isSame, entry.samesCount, entry.firstSameDateTime);
            positionsList.push(position);
        }
        return positionsList;
    }

    private extractPositionsFromJSON(res: Response | any) {
        let body = res.json();
        var positionsList:Position[] = []; 
        console.log('Total positions => ' + body.length);
        for (let entry of body) {
            if (!entry.id) { return; }

            var dateTime = new Date(entry.dateTime);
            dateTime.setHours(dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds(), 0);

            var position:Position = new Position(entry.id, entry.idTracker, +entry.lat, +entry.lng, dateTime, entry.velocity, entry.start, entry.address, entry.isSame, entry.samesCount, entry.firstSameDateTime);

            // var position:Position = new Position(null, null, null, null, null, null, null, null);
            // positionsList.push(position);
            //position = JSON.parse(JSON.stringify(entry));
            //var position:Position = new Position();
            
            //se é uma posição diferente ou se ainda não tem na lista, adiciona
            if (!position.isSame) { // || positionsList.length == 0){
                positionsList.push(position);
            }
            // = JSON.parse(body);
            //console.log('positionsList: ' + positionsList);
            

        }
        return positionsList;
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/tracker.service.ts